<template>
  <div><b-button href="https://admin.bauvisor.com" target="_blank">Zur Kundenverwaltung</b-button></div>
</template>

<script>
import AppState from '@/store/App.js';

export default {
  async activated() {
    AppState.isLoading = false;
    if (!this.$root.$user.isCustomerAdmin) this.$router.push('/');
  }
};
</script>

<style></style>
